import type { ApiSearchQuery } from '@/lib/api/api-type-helper';
import { ALL_TASK_TAB } from '../-constants';
type RequestTaskApiFilter = NonNullable<ApiSearchQuery<'/v2/self-service/request-tasks', 'get'>['filter']>;
const requestTaskStatusTabs = {
  NOT_SUBMITTED: 'NotSubmitted',
  PENDING_APPROVAL: 'PendingApproval',
  RETURNED: 'Returned',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
} as const satisfies Record<string, RequestTaskApiFilter>;
export const RequestTaskTab = {
  ...requestTaskStatusTabs,
  ALL: ALL_TASK_TAB
} as const;
export type RequestTaskTab = (typeof RequestTaskTab)[keyof typeof RequestTaskTab];

// ALL タブ・未指定は filter="All"（フィルタなし=全件）。
// 未指定だと API 側は Default（Approved / Rejected 除外）になるため明示する。
export function toRequestTaskApiFilter(tab?: RequestTaskTab): RequestTaskApiFilter {
  if (!tab || tab === RequestTaskTab.ALL) {
    return 'All';
  }
  return tab;
}